// extracted by mini-css-extract-plugin
export default {"checkBoxLabel":"KV_cHq5xej1uXLDNMpKc","error":"Yw8HSXDi2o0TeIue2BEG","checkboxError":"C2fG7OMrwckRhTTiTD4g"};